import React from "react";
import { BsGithub } from "react-icons/bs";
import { FaBlogger } from "react-icons/fa";

function Header() {
  return (
    <div className="my-10 flex justify-between">
      <div className="font-bold text-3xl">sonbuwon7</div>
      <div>
        <ul className="flex">
          {/* 깃허브 링크 */}
          <li className="ml-2">
            <a
              href="https://github.com/sonbuwon"
              className=""
              target="_blank"
              rel="noreferrer"
            >
              <BsGithub className="w-8 h-8" />
            </a>
          </li>
          {/* 구글 블로거 링크 */}
          <li className="ml-2">
            <a
              href="https://bhilso.blogspot.com/"
              className=""
              target="_blank"
              rel="noreferrer"
            >
              <FaBlogger className="w-8 h-8" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Header;
